import React from "react";
import * as ServiceStyles from "./styles/SharedService";
import { BnbLabel } from "../../../utils/labels";
import { type BuildAndBuyDispatchType, useBnbSelector } from "../../../redux/store";
import useService from "../../../hooks/services/useService";
import { ServiceTypeEnum } from "../../../../../../common-deprecated/types/SettingsType";
import { formatPrice } from "../../../../../../common-deprecated/Globalize";
import * as Type from "../../../../../../common-deprecated/styles/lexus/Type";
import * as Button from "../../../../../../common-deprecated/styles/v2/lexus/components/Button";
import Icon from "../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import { IconWrapper } from "../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import { showModal } from "../../../../../../common-deprecated/redux/actions/ModalActions";
import { clearTradeInAemExtData } from "../../../../../../common-deprecated/features/tradein/redux/actions/TradeInAemExternalDataActions";
import { MODAL_INTEGRATED_TRADE_IN_AEM } from "../../../../../../shared-logic/features/tradein/utils/integratedModalConstants";
import { trackCtaCalculator } from "../../../utils/tracking";
import { NavStep } from "../../../../shared-logic/utils/Navigation";
import { useDispatch } from "../../../../../../shared-logic/redux/store";

const TradeInService = (): JSX.Element | null => {
    const dispatch = useDispatch<BuildAndBuyDispatchType>();
    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const { vehicleName, vehicleValue } = useBnbSelector((state) => state.tradeInAemExternalData.data);

    const vehicleTitle = vehicleName ? `${vehicleName.name} ${vehicleName?.description || ""}` : "";
    const tradeInSet = !!vehicleTitle && !!vehicleValue;
    const formattedPrice = formatPrice(vehicleValue || 0, commonSettings.culture.name).replace(" ", "&nbsp;");

    // get other service labels
    const data = useService(ServiceTypeEnum.Tradein);
    if (!data) return null;
    const { title, description, bannerLinkImage } = data;

    return (
        <ServiceStyles.ServiceWrapper selected={tradeInSet}>
            {bannerLinkImage && (
                <ServiceStyles.Banner>
                    <ServiceStyles.Image src={`${bannerLinkImage}`} height={170} />
                </ServiceStyles.Banner>
            )}

            <ServiceStyles.Title>
                {title ? <span>{title}</span> : <BnbLabel label="partExchange" />}
            </ServiceStyles.Title>

            {description && <ServiceStyles.Description dangerouslySetInnerHTML={{ __html: data.description! }} />}

            <ServiceStyles.TradeInWrapper topBorder={tradeInSet}>
                {tradeInSet && (
                    <>
                        <span>{vehicleTitle}</span>
                        <Type.Strong>
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: `${formattedPrice}`,
                                }}
                            />
                        </Type.Strong>
                    </>
                )}

                <Button.Checkbox
                    selected={tradeInSet}
                    onClick={() => {
                        trackCtaCalculator(NavStep.Services, "tradein-calculator");
                        if (tradeInSet) {
                            dispatch(clearTradeInAemExtData());
                        } else {
                            dispatch(showModal({ type: MODAL_INTEGRATED_TRADE_IN_AEM }));
                        }
                    }}
                >
                    <IconWrapper>
                        <Icon variant={tradeInSet ? "close" : "plus"} />
                    </IconWrapper>
                </Button.Checkbox>
            </ServiceStyles.TradeInWrapper>
        </ServiceStyles.ServiceWrapper>
    );
};

export default TradeInService;
